<template>
  <div>
    <div>
      <tree-select
        v-if="orgBack&&orgId==1"
        @treeAll="getOrgValue"
        @reset="orgName=''"
        :disabled="false"
        style="
          width: 200px;
          display: inline-block;
          verticalAlign: bottom;
          fontsize: 14px;
        "
        placeholder="请输入医院名称"
        :option="orgOption"
      ></tree-select>
       <tree-select-sec
        v-if="orgBack&&orgId!=1"
         @reset="orgName=''"
        @treeAll="getOrgValue"
        :disabled="false"
        style="
          width: 200px;
          display: inline-block;
          verticalAlign: bottom;
          fontsize: 14px;
        "
        placeholder="请输入医院名称"
        :option="orgOption"
      ></tree-select-sec>
       <el-input size="medium" clearable style="width:200px" placeholder="输入查找年份" v-model="intyear"></el-input>
      <el-button size="medium" @click="getpage(1)">筛选</el-button>
    </div>
    <el-divider></el-divider>
    <div>
      <el-table :data="list" border >
        <el-table-column align="center" label="所属医院">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <p>所属医院: {{ scope.row.orgName }}</p>
              <div slot="reference" class="name-wrapper">
                <el-tag size="medium">{{ scope.row.orgName }}</el-tag>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column align="center" label="年份">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.intyear }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="一月">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.oneTotal*coefficient+Number(base)}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="二月">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.twoTotal*coefficient+Number(base) }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="三月">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.threeTotal*coefficient+Number(base) }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="四月">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.fourTotal*coefficient+Number(base) }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="五月">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.fiveTotal*coefficient+Number(base) }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="六月">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.sixTotal*coefficient+Number(base) }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="七月">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.sevenTotal*coefficient+Number(base) }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="八月">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.eightTotal*coefficient+Number(base) }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="九月">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.nineTotal*coefficient+Number(base) }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="十月">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.tenTotal*coefficient+Number(base) }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="十一月">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.elevenTotal*coefficient+Number(base) }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="十二月">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.twelveTotal*coefficient+Number(base) }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="本年">
          <template slot-scope="scope">
            <span style="margin-left: 10px">
              {{
                scope.row.oneTotal*coefficient+
                scope.row.twoTotal*coefficient+
                scope.row.threeTotal*coefficient+
                scope.row.fourTotal*coefficient+
                scope.row.fiveTotal*coefficient+
                scope.row.sixTotal*coefficient+
                scope.row.sevenTotal*coefficient+
                scope.row.eightTotal*coefficient+
                scope.row.nineTotal*coefficient+
                scope.row.tenTotal*coefficient+
                scope.row.elevenTotal*coefficient+
                scope.row.twelveTotal*coefficient+
                base*12
              }}
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <page
      @givePageIndex="getpage"
      :index="page"
      :pageSize="pageSize"
      :total="total"
    ></page>
     <el-divider v-if="openFlag"></el-divider>
     <div v-if="openFlag">
       <label >基数：</label><el-input clearable style="width:200px" placeholder="请输入基数" v-model="base"></el-input>
         <label style="marginLeft:20px">系数：</label>  <el-input clearable style="width:200px" placeholder="请输入系数数" v-model="coefficient"></el-input>
     </div>
    <el-dialog
      title="查看统计图"
      :visible.sync="dialogVisible"
      width="60%"
      :close-on-click-modal="false"
    >
      <div>
        <el-select v-model="typeValue" placeholder="请选择">
          <el-option
            v-for="item in typeList"
            :key="item.value"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>

      <span>内容开发。。。</span>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>-->
    </el-dialog>
  </div>
</template>

<script>
import treeSelect from "../../components/treeSelect";
import treeSelectSec from "./treeSelect1";
import page from "../../components/pages";
export default {
  components: {
    treeSelect,
    page,
    treeSelectSec
  },
  created(){
    this.orgId=sessionStorage.getItem('orgId')
    this.openFlag = sessionStorage.getItem("admin") == 'admin' ? true : false
  },
  mounted() {
    this.load();
    this.getOrgList()
  },
  data() {
    return {
      orgId:'',
      orgBack:false,
      orgOption:[],
      intyear:'',
      base:0,//基数
      coefficient:1,//系数
      dialogVisible: false,
      orgName: "",
      page: 1,
      pageSize: 10,
      total: 0,
      list: [],
      typeList: [],
      typeValue: "",
      openFlag:false
    };
  },
  methods: {
    getOrgValue(x){
      this.orgName=x.name
    },
    getOrgList(){
       this.orgBack = false
       this.$api.structureChildrenList().then((res) => {
      console.log(res)
      if (res.data.code == 200) {
        this.orgBack = true;

        this.orgOption = res.data.data;
      }
    });
    },
    load() {
      let obj = {
        pageNo: this.page,
        pageSize: this.pageSize,
        orgName:this.orgName,
        // search: this.search,
        intyear:this.intyear
      };
      console.log(obj);
      this.$api.hospitalTotal(obj).then((res) => {
        console.log(res);
        if (res.data.code == 200) {
          this.list = res.data.data.records;
          this.page = res.data.data.current;
          this.pageSize = res.data.data.size;
          this.total = res.data.data.total;
        }
      });
    },
    getpage(x) {
      //分页
      console.log(x);
      this.page = x;
      this.load();
    },
  },
};
</script>

<style scoped>
</style>